import { ValidationResult } from "./models/ValidationResult";

export const isNotEmpty = (errorMessage: () => string) => (value: string) => {
  if (value.trim() !== "") return <ValidationResult>{ isValid: true };
  return <ValidationResult>{
    isValid: false,
    errorMessage: errorMessage()
  };
};
